// Load the YouTube IFrame API once
(function loadYouTubeAPI() {
  if (window.YT && window.YT.Player) return;
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);
})();

let previewModal = null;
let modalContent = null;
let modalCloseBtn = null;

let modalPlayer = null;          // shared modal player
let currentPreviewPlayer = null; // preview that opened the modal

// --- modal setup ---
function setupModal() {
  previewModal = document.querySelector('.preview-video-modal');
  if (!previewModal) return;

  modalContent = previewModal.querySelector('.modal-container');
  modalCloseBtn = previewModal.querySelector('.close-modal');

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', () => {
      if (typeof previewModal.close === 'function') {
        previewModal.close();
      }
    });
  }

  previewModal.addEventListener('click', (event) => {
    if (event.target === previewModal && typeof previewModal.close === 'function') {
      previewModal.close();
    }
  });

  previewModal.addEventListener('close', () => {
    if (modalPlayer && modalPlayer.stopVideo) {
      modalPlayer.stopVideo();
    }
    if (currentPreviewPlayer && currentPreviewPlayer.playVideo) {
      currentPreviewPlayer.playVideo();
    }
    currentPreviewPlayer = null;
  });
}

// --- called once API is ready ---
function initAllPlayers() {;

  setupModal();

  const wrappers = document.querySelectorAll('.inline-video[data-youtube-id]');

  wrappers.forEach((wrapper, i) => {
    if (wrapper.dataset.ytInitialized === 'true') return;
    wrapper.dataset.ytInitialized = 'true';

    const videoId = wrapper.dataset.youtubeId;
    const previewContainer = wrapper.querySelector('.preview-player');
    const openBtn = wrapper.querySelector('.open-modal');

    if (!videoId || !previewContainer || !openBtn) return;

    const originalDisplay = openBtn.style.display;
    openBtn.style.display = 'none';

    const previewPlayer = new YT.Player(previewContainer, {
      videoId,
      height: '390',
      width: '640',
      playerVars: {
        autoplay: 1,         // 🔥 turn autoplay back on
        mute: 1,             // required for Safari autoplay
        controls: 0,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      },
      events: {
        onReady: (event) => {
          const player = event.target;
          player.mute();
          player.playVideo(); // kick it in case autoplay flag alone isn't enough

          // set up modal open
          openBtn.addEventListener('click', () => {
            if (!previewModal) {
              setupModal();
            }
            if (!previewModal || !modalContent) return;

            currentPreviewPlayer = previewPlayer;
            if (previewPlayer.pauseVideo) {
              previewPlayer.pauseVideo();
            }

            // ensure modal container for player
            let fullPlayerDiv = modalContent.querySelector('.modal-player');
            if (!fullPlayerDiv) {
              fullPlayerDiv = document.createElement('div');
              fullPlayerDiv.classList.add('modal-player');
              fullPlayerDiv.id = 'preview-video-modal-player';
              fullPlayerDiv.style.width = '640px';
              fullPlayerDiv.style.height = '390px';

              if (modalCloseBtn) {
                modalContent.insertBefore(fullPlayerDiv, modalCloseBtn);
              } else {
                modalContent.appendChild(fullPlayerDiv);
              }
            }

            if (typeof previewModal.showModal === 'function') {
              previewModal.showModal();
            }

            if (!modalPlayer) {
              modalPlayer = new YT.Player('preview-video-modal-player', {
                videoId,
                height: '390',
                width: '640',
                playerVars: {
                  autoplay: 1,
                  mute: 0,
                  controls: 1,
                  modestbranding: 1,
                  playsinline: 1,
                  rel: 0
                },
                events: {
                  onReady: (e) => e.target.playVideo()
                }
              });
            } else {
              modalPlayer.loadVideoById(videoId);
              modalPlayer.playVideo();
            }
          });

          openBtn.style.display = originalDisplay;
        },
        onStateChange: (event) => {
          if (event.data === YT.PlayerState.ENDED) {
            event.target.seekTo(0);
            event.target.playVideo();
          }
        }
      }
    });
  });
}

// YouTube API callback
window.onYouTubeIframeAPIReady = function () {
  initAllPlayers();
};

// in case API loads before DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  if (window.YT && window.YT.Player) {
    initAllPlayers();
  }
});